import React, { useState } from 'react'
import { DropdownMenu, DropdownToggle, UncontrolledDropdown, DropdownItem } from "reactstrap";
import ActionSend from "./bulk-actions/ActionSend"

const BulkActions = ({selectedItems, refreshBatches, setSelectedItems}) => {
    const [isOpen, setIsOpen] = useState(false)

    const _showModal = () => {
        setIsOpen(true)
    }

    const _closeModal = () => {
        setIsOpen(false)
    }

    return (
        <UncontrolledDropdown className='MenuActions'>
            <DropdownToggle tag='span' className='ToggleActions'>
                <span
                    className='border rounded d-inline-flex px-2 py-1 bg-light font-weight-normal align-items-baseline cursor-pointer'>
                    Hành động <i className="fa fa-caret-down ml-2" />
                </span>
            </DropdownToggle>

            <DropdownMenu>
                <DropdownItem onClick={_showModal}>Tái tạo lô</DropdownItem>
            </DropdownMenu>

            <ActionSend
                isOpen={isOpen}
                closeModal={_closeModal}
                selectedItems={selectedItems}
                refreshBatches={refreshBatches}
                setSelectedItems={setSelectedItems}
            />
        </UncontrolledDropdown>
    )
}

export default BulkActions
